import React, { Component } from "react";
import { withStyles, styled } from "@material-ui/core/styles";
import Typography from "@material-ui/core/Typography";
import { Grid, TextField, Snackbar } from "@material-ui/core";
import { withRouter } from "react-router-dom";
import { Table, DatePicker, Button, Input, Select, Tooltip } from 'antd';
import { CloseOutlined, DeleteOutlined, SearchOutlined } from '@ant-design/icons'

import { 
  getMonitorList,
  getMonitorOptions
} from '../../actions/monitor'

const { RangePicker } = DatePicker;
const { Option } = Select;


const styles = () => {
  return {
    root: {
      width: "100%",
    },
    search: {
      width: "100%",
      height: "61px",
      padding: "18px 24px",
      flexFlow: "column",
      background: "#fff",
    },
    line: {
      height: "25px",
      fontSize: "14px",
      color: "#000",
      display: "flex",
      alignItems: "center",
      justifyContent: "space-between"
    },
    title: {
      marginRight: "10px",
      fontSize: "18px",
      fontWeight: "bold",
      color: "#5F6876",
    },
    btn: {
      width: "70px",
      height: "40px",
      background: "#3276C3",
      borderRadius: "0 !important",
    },
    container: {
      paddingTop: "20px",
    },
    dateFilter: {
      width: "236px",
      padding: "8px",
    },
    defaultFilter: {
      width: "196px",
      padding: "8px",
    },
    btnLine: {
      marginTop: "8px",
      display: 'flex',
      justifyContent: 'space-between'
    },
    select: {
      width: '100%'
    },
    tableContainer: {
      width: '100%',
      '& .ant-table-cell-row-hover': {
        background: '#f0fbff !important'
      },
      '& td.ant-table-column-sort': {
        background: '#f0fbff !important'
      }
    }
  };
};

class Monitor extends Component {
  constructor(props){
    super(props);
  }

  state = {
    loading: true,
    filteredInfo: null,
    filterForm: {},
    filterDropdownVisible: false,
    columns: [],
    data: [],
    siteList: [],
    companyList: [],
    updateTime: '',
    searchHistoryList: [],
    form: {},
    defaultForm: { // 默认值
      KeyWord: "",
      recallingFirm: undefined,
      productDescription: "",
      recallClass: undefined,
      recallPostingDate: [],
      recallPostingSite: undefined,
      recallNumber: "",
      reasonForRecall: "",
      url: "",
      registrationNumber: "",
    },
    labelObj: { // 筛选项key - label对应关系
      KeyWord: '关键词',
      recallingFirm: '召回公司',
      productDescription: '召回产品名称',
      recallClass: '召回级别',
      recallPostingDate: '报告日期',
      recallPostingSite: '报告网站',
      recallNumber: '召回编号',
      reasonForRecall: '召回原因简述',
      url: '网页地址',
      registrationNumber: '注册证编号',
    },
    labelListObj: { 
      recallClass: 'levelList',
      recallPostingSite: 'siteList',
      recallingFirm: 'companyList'
    },
    selectKeys: ['recallClass', 'recallPostingSite', 'recallingFirm'],
    sortObj: {},
    levelList: [
      {
        ID: '1',
        Name: '1级'
      },
      {
        ID: '2',
        Name: '2级'
      },
      {
        ID: '3',
        Name: '3级'
      },
    ],
    timer: '',
    page: {
      page: 1,
      pageSize: 10
    },
    total: 0,
    scrollObj: {
      x: 2070,
      y: 600
    },
    paginationObj: {
      showSizeChanger: true,
      allTotal: 0,
      total: 0,
      showTotal: (total, range) => {
        return '共【' + this.state.paginationObj.total + '】条数据'
        // return '当前已筛选出【' + this.state.paginationObj.total + '】条，总数据量【' + this.state.paginationObj.allTotal + '】条'
      },
      onChange: (page, pageSize) => {
        this.pageChange(page, pageSize)
      },
    }
  };

  componentDidMount() {
    let date = new Date()
    let year = date.getFullYear()
    let month = date.getMonth() + 1
    let day = date.getDate()
    let today = `${year}-${month < 10 ? `0${month}` : month}-${day < 10 ? `0${day}` : day}`
    this.setState({
      updateTime: today
    })

    // 计算表格高度
    let height = window.innerHeight
    this.setState({
      scrollObj: {
        x: 2070,
        y: height - 265,
      },
    });
    let search = decodeURI(this.props.location.search)
    let params = search.substring(1).split('&')
    let obj = params.find(v => {
      return v.indexOf('keyword=') == 0
    })
    if (obj) {
      let urlKeyword = obj.split('=')[1]
      this.setState({
        form: {
          ...this.state.form,
          KeyWord: urlKeyword,
        },
        showKeys: ['KeyWord']
      }, () => this.initData())
    } else {
      this.initData()
    }

    this.initParam()
  }

  resetForm = () => {
    this.setState({
      form: {
        KeyWord: "",
        recallingFirm: "",
        productDescription: "",
        recallClass: undefined,
        recallPostingDate: [],
        recallPostingSite: "",
        recallNumber: "",
        reasonForRecall: "",
        url: "",
        registrationNumber: "",
      }
    })
  }

  clearHistory = () => {
    this.resetForm()
    this.setState({
      searchHistoryList: []
    }, () => this.initData())
  }

  removeSearchItem = (data, i) => {
    let form = {
      ...this.state.form
    }
    let list = [].concat(this.state.searchHistoryList)
    form[data.key] = this.state.defaultForm[data.key]
    list.splice(i, 1)
    this.setState({
      form: form,
      searchHistoryList: list
    }, () => this.initData())
  }

  searchForm = () => {
    this.initData()
    // 添加历史搜索记录
    let form = {
      ...this.state.form
    }
    let list = [].concat(this.state.searchHistoryList)
    for (let key in form) {
      let index = list.findIndex(v => {
        return v.key == key
      })
      if (form[key] && form[key].length > 0) {
        let showValue = form[key]
        let label = ''
        if (key == 'recallPostingDate') {
          showValue = `${showValue[0].format("YYYY-MM-DD")} - ${showValue[1].format("YYYY-MM-DD")}`
        }
        if (this.state.selectKeys.indexOf(key) > -1) {
          label = this.state[this.state.labelListObj[key]].find(v => {
            return v.ID == showValue
          }).Name
        }
        if (index === -1) {
          let param = {
            label: this.state.labelObj[key],
            value: label || showValue,
            key: key
          } 
          list.push(param)
        } else {
          let itemIndex = list.findIndex(v => {
            return v.key == key
          })
          list[itemIndex].value = label || showValue
        }
      } else {
        if (index > -1) {
          list.splice(index, 1)
        }
      }
    }
    this.setState({
      searchHistoryList: list
    })
  }

  onChangeForm = (value, key) => {
    let form = {
      ...this.state.form
    }
    form[key] = value
    this.setState({
      form: form
    })
  }

  initData = () => {
    let recallPostingDate = this.state.form.recallPostingDate
    let param =  Object.assign({}, this.state.form, this.state.page)
    if (recallPostingDate && recallPostingDate.length > 0) {
      param.startRecallPostingDate = recallPostingDate[0].format("YYYY-MM-DD")
      param.endRecallPostingDate = recallPostingDate[1].format("YYYY-MM-DD")
    }
    delete(param.recallPostingDate)
    getMonitorList(param).then(res => {
      if (res && res.DataList) {
        let newPaginationObj = this.state.paginationObj
        newPaginationObj.total = res.DataNumber
        newPaginationObj.allTotal = res.UnfilteredAllDataNumber
        this.setState({
          data: res.DataList.map(v => {
            v.CorporateName = v.ApplicantCompanyOrApplicantProcessingCompany
            return v
          }),
          paginationObj: newPaginationObj,
          loading: false
        }, () => {
          this.getColumns()
        })
      } else {
        this.setState({
          loading: false
        })
      }
    })
  }

  initParam = () => {
    getMonitorOptions().then(res => {
      let data = res.data
      this.setState({
        siteList: (data.recallPostingSite || []).map(v => {
          return {
            ID: v,
            Name: v
          }
        }),
        companyList: (data.recallingFirm || []).map(v => {
          return {
            ID: v,
            Name: v
          }
        }),
      })
    })
  }

  getColumns = () => {
    let classes = this.props.classes

    let columns = [
      {
        title: '召回公司',
        dataIndex: 'recallingFirm',
        key: 'recallingFirm',
        width: 300,
      },
      {
        title: '召回产品名称',
        dataIndex: 'productDescription',
        width: 260,
        key: 'productDescription',
      },
      {
        title: '召回级别',
        dataIndex: 'recallClass',
        key: 'recallClass',
        width: 150,
        render: (value) => (
          <span>{`${value}级`}</span>
        )
      },
      {
        title: '报告日期',
        dataIndex: 'recallPostingDate',
        key: 'recallPostingDate',
        width: 160,
        render: (value) => (
          <span>{value ? value.substring(0,10) : ''}</span>
        )
      },
      {
        title: '报告网站',
        dataIndex: 'recallPostingSite',
        key: 'recallPostingSite',
        width: 200,
      },
      {
        title: '召回编号',
        dataIndex: 'recallNumber',
        key: 'recallNumber',
        width: 160,
      },
      {
        title: '召回原因简述',
        dataIndex: 'reasonForRecall',
        key: 'reasonForRecall',
        width: 340,
        ellipsis: {
          showTitle: false,
        },
        render: (_, record) => {
          let content = record.reasonForRecall || ''
          return   <Tooltip placement="topLeft" title={content}>
            <span >{content}</span>
          </Tooltip>
        },
      },
      {
        title: '网页地址',
        dataIndex: 'url',
        key: 'url',
        width: 300,
        render: (_, record) => {
          return <a href={record.url} target="_blank">{record.url}</a>
        },
      },
      {
        title: '注册证编号',
        dataIndex: 'registrationNumber',
        key: 'registrationNumber',
        width: 200,
      },
    ]

    this.setState({
      columns: columns,
    })
  }

  handleChange = (pagination, filters, sorter) => {
    this.setState(
      {
        loading: true,
      },
      () => {
        this.getColumns();
        this.initData();
      }
    );
  };

  pageChange = (page, pageSize) => {
    if (page == this.state.page.page && pageSize == this.state.page.pageSize) {
      return
    }
    this.setState({
      page: {
        page: page,
        pageSize: pageSize
      },
      loading: true
    }, () => this.initData())
  }

  render() {
    const classes = this.props.classes;

    return (
      <div className="common-page">
        <div className="common-left-search">
          <div className="left-search-title">
            <span className="search-title">关键词搜索</span>
            
          </div>
          <div className="search-form">
            <div className="form-item">
              <div className="form-label">关键词</div>
              <Input  value={this.state.form.KeyWord}
                allowClear
                onChange={(e) => this.onChangeForm(e.target.value, 'KeyWord')} 
                placeholder="请输入关键词"/>
            </div>
            <div className="form-item">
              <div className="form-label">召回公司</div>
              <Select
                allowClear
                className={classes.select}
                placeholder="请选择"
                value={this.state.form.recallingFirm}
                onChange={(e) => this.onChangeForm(e, 'recallingFirm')} 
              >
                {
                  this.state.companyList.map((v, i) => {
                    return (
                      <Option value={v.ID} key={i}>{v.Name}</Option>
                    )
                  })
                }
              </Select>
            </div>
            <div className="form-item">
              <div className="form-label">召回产品名称</div>
              <Input  value={this.state.form.productDescription}
                allowClear
                onChange={(e) => this.onChangeForm(e.target.value, 'productDescription')} 
                placeholder="请输入召回产品名称"/>
            </div>
            <div className="form-item">
              <div className="form-label">召回级别</div>
                <Select
                  allowClear
                  className={classes.select}
                  placeholder="请选择"
                  value={this.state.form.recallClass}
                  onChange={(e) => this.onChangeForm(e, 'recallClass')} 
                >
                  {
                    this.state.levelList.map((v, i) => {
                      return (
                        <Option value={v.ID} key={i}>{v.Name}</Option>
                      )
                    })
                  }
                </Select>
            </div>
            <div className="form-item">
              <div className="form-label">报告日期</div>
              <RangePicker
                allowClear
                value={this.state.form.recallPostingDate}
                onChange={(value) => this.onChangeForm(value, 'recallPostingDate')}
              />
            </div>
            <div className="form-item">
              <div className="form-label">报告网站</div>
              <Select
                allowClear
                className={classes.select}
                placeholder="请选择"
                value={this.state.form.recallPostingSite}
                onChange={(e) => this.onChangeForm(e, 'recallPostingSite')} 
              >
                {
                  this.state.siteList.map((v, i) => {
                    return (
                      <Option value={v.ID} key={i}>{v.Name}</Option>
                    )
                  })
                }
              </Select>
            </div>
            <div className="form-item">
              <div className="form-label">召回编号</div>
              <Input  value={this.state.form.recallNumber}
                allowClear
                onChange={(e) => this.onChangeForm(e.target.value, 'recallNumber')} 
                placeholder="请输入召回编号"/>
            </div>
            <div className="form-item">
              <div className="form-label">召回原因简述</div>
              <Input  value={this.state.form.reasonForRecall}
                allowClear
                onChange={(e) => this.onChangeForm(e.target.value, 'reasonForRecall')} 
                placeholder="请输入召回原因简述"/>
            </div>
            <div className="form-item">
              <div className="form-label">网页地址</div>
              <Input  value={this.state.form.url}
                allowClear
                onChange={(e) => this.onChangeForm(e.target.value, 'url')} 
                placeholder="请输入网页地址"/>
            </div>
            <div className="form-item">
              <div className="form-label">注册证编号</div>
              <Input  value={this.state.form.registrationNumber}
                allowClear
                onChange={(e) => this.onChangeForm(e.target.value, 'registrationNumber')} 
                placeholder="请输入注册证编号"/>
            </div>
          </div>

          <div className="search-bottom-btns">
            <Button className="default-btn" onClick={this.resetForm}>重置</Button>
            <Button className="primary-btn" onClick={this.searchForm}>搜索</Button>
          </div>
        </div>

        <div className="common-main">
          <div className="common-main-search">
            <div className="main-title">
              <div className="title-top">
                <div>
                  <span className="page-title">警戒监测</span>
                  <span className="page-count">{this.state.paginationObj.total}条</span>
                </div>
                <span >数据更新至：{this.state.updateTime}</span>
              </div>
            </div>
            {
              this.state.searchHistoryList.length > 0 &&
              <div className="search-history">
                {
                  this.state.searchHistoryList.map((item, i) => (
                    <div className="history-item" key={i}>
                      <span>{item.label}：</span>
                      <span className="history-value">{item.value}</span>
                      <CloseOutlined className="clear-icon" onClick={() => this.removeSearchItem(item, i)}/>
                    </div>
                  ))
                }
                <div className="hitstory-btn" onClick={this.clearHistory}>
                  <DeleteOutlined className="btn-icon"/>
                  清空
                </div>
              </div>
            }
          </div>
          <div className="common-main-container">
            <Grid container className={classes.container} id="tableContainer">
              <Table 
                className={classes.tableContainer}
                columns={this.state.columns} 
                loading={this.state.loading} 
                dataSource={this.state.data} 
                onChange={this.handleChange} 
                scroll={this.state.scrollObj}
                pagination={this.state.paginationObj}
                bordered
                />
              
            </Grid>
          </div>
        </div>
      </div>
    );
  }
}

export default withStyles(styles)(withRouter(Monitor));
